import React from "react";
import Table from "../../../../components/Table";
import Button from "../../../../components/Button";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import { Link } from "react-router-dom";

export default function LocationComponent({ dataLocations, isLoading }) {
  const localize = useLocalization();
  const columns = [
    { label: localize.getText("id") },
    { label: localize.getText("name") },
    {
      label: localize.getText("action"),
      className: "text-center",
      style: { width: "200px" },
    },
  ];

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-end">
        <Link to="/location/add-location">
          <Button label={localize.getText("addLocation")} size="btn-sm" />
        </Link>
      </div>
      <div className="card-body">
        <Table
          columns={columns}
          loading={isLoading}
          activePage={0}
          totalPage={0}
          totalShow={dataLocations.length}
          totalEntries={dataLocations.length}
          handlePagination={() => {}}
          noPagination
        >
          {dataLocations.map((item, index) => (
            <tr key={index}>
              <td className="sorting_1">{item.resource.id}</td>
              <td>{item.resource.name}</td>
              <td>
                <div className="d-flex justify-content-center gap-3">
                  {/* <Button variant="danger">
                      <i class="fas fa-trash"></i>
                    </Button> */}
                  <Link
                    to={{
                      pathname: "/location/detail-Location",
                      search: `?id=${item.resource.id}`,
                      state: item,
                    }}
                  >
                    <Button variant="warning">
                      <i class="fas fa-eye"></i>
                    </Button>
                  </Link>
                  <Link
                    to={{
                      pathname: "/location/edit-Location",
                      search: `?id=${item.resource.id}`,
                      state: item,
                    }}
                  >
                    <Button variant="info">
                      <i class="fas fa-edit"></i>
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </Table>
      </div>
    </div>
  );
}
